import { render, staticRenderFns } from "./GridPromotionSwiper.vue?vue&type=template&id=80896b84&scoped=true"
import script from "./GridPromotionSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridPromotionSwiper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridPromotionSwiper.vue?vue&type=style&index=0&id=80896b84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80896b84",
  null
  
)

export default component.exports